// extracted by mini-css-extract-plugin
export default {"autocomplete":"awraLg","bottom":"bwraLg","top":"cwraLg","option":"dwraLg"};